import { formatDate } from "./ScheduleUtils";

export const ALLOWED_PATIENT_BOOKING_HORIZON_DAYS = [30, 60, 90, 120];
export const DEFAULT_PATIENT_BOOKING_HORIZON_DAYS = 60;

export function normalizePatientBookingHorizonDays(value) {
  const parsed = Number(value);
  if (ALLOWED_PATIENT_BOOKING_HORIZON_DAYS.includes(parsed)) {
    return parsed;
  }
  return DEFAULT_PATIENT_BOOKING_HORIZON_DAYS;
}

export function getMaxBookingDate(horizonDays, fromDate = new Date()) {
  const max = new Date(fromDate);
  max.setHours(0, 0, 0, 0);
  max.setDate(max.getDate() + normalizePatientBookingHorizonDays(horizonDays));
  return max;
}

export function isDateWithinBookingHorizon(date, horizonDays, fromDate = new Date()) {
  const normalized = new Date(date);
  normalized.setHours(0, 0, 0, 0);

  const today = new Date(fromDate);
  today.setHours(0, 0, 0, 0);

  const maxDate = getMaxBookingDate(horizonDays, today);

  return normalized > today && normalized <= maxDate;
}

export function isAppointmentDateWithinHorizon(appointmentDate, horizonDays) {
  const dateStr =
    typeof appointmentDate === "string"
      ? appointmentDate.slice(0, 10)
      : formatDate(appointmentDate);
  const [y, m, d] = dateStr.split("-").map(Number);
  return isDateWithinBookingHorizon(new Date(y, m - 1, d), horizonDays);
}
